module.exports = __webpack_public_path__ + "img/astronaut.d34e8b6a.png";